import React from 'react';
import { YELLOW } from '../../HOME/const';

const SVG = ({ style = {}, color = YELLOW, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g stroke={color} strokeWidth="8" strokeLinecap="round">
      <circle cx="50" cy="50" r="46" fill="none" />
      <circle cx="62" cy="21" r="7" strokeWidth="0" fill={color} />
      <line x1="23" y1="29" x2="40" y2="23" />
      <line x1="40" y1="23" x2="55" y2="32" />
      <line x1="55" y1="32" x2="46" y2="47" />
      <line x1="46" y1="47" x2="63" y2="61" />
      <line x1="63" y1="61" x2="69" y2="78" />

      <line x1="64" y1="37" x2="72" y2="40" />
      <line x1="72" y1="40" x2="83" y2="38" />

      <line x1="42" y1="56" x2="35" y2="65" />
      <line x1="35" y1="65" x2="20" y2="67" />
    </g>
  </svg>
);

export default SVG;
